import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraph = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M5 16C5 17.1046 4.10457 18 3 18C1.89543 18 1 17.1046 1 16C1 14.8954 1.89543 14 3 14C4.10457 14 5 14.8954 5 16Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M17 14C17 15.1046 16.1046 16 15 16C13.8954 16 13 15.1046 13 14C13 12.8954 13.8954 12 15 12C16.1046 12 17 12.8954 17 14Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M23 8C23 9.10457 22.1046 10 21 10C19.8954 10 19 9.10457 19 8C19 6.89543 19.8954 6 21 6C22.1046 6 23 6.89543 23 8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.7071 8.70711L15.7071 14.7071C15.3166 15.0976 14.6834 15.0976 14.2929 14.7071L10 10.4142L3.70711 16.7071L2.29289 15.2929L9.29289 8.29289C9.68342 7.90237 10.3166 7.90237 10.7071 8.29289L15 12.5858L20.2929 7.29289L21.7071 8.70711Z"
		})
	]
});
export default SvgGraph;
